import { ExtraPaymentLineData } from '../api';

const initialEditOrderState: EditOrderState = {
  shouldAllowPriceOverride: false,
  calculatedPrice: 0,
  extraPaymentsLines: [],
};

export enum VoucherError {
  NOT_FOUND = 'NOT_FOUND',
  ALREADY_USED = 'ALREADY_USED',
  EXPIRED = 'EXPIRED',
  ARCHIVED = 'ARCHIVED',
}

export enum SpecificEventError {
  NO_MORE_TICKETS = 'NO_MORE_TICKETS',
}

export type CustomTheme = {
  textColor: string;
  borderColor: string;
  backgroundColor: string;
};

export type EditOrderState = {
  shouldAllowPriceOverride: boolean;
  calculatedPrice: number;
  extraPaymentsLines: ExtraPaymentLineData[];
};

const getDefaultCustomDetails = (orderPage: any) => {
  const result = {};
  for (const customDetail of orderPage.custom_details) {
    if (customDetail.default_value) {
      // @ts-ignore
      result[customDetail.name] = customDetail.default_value;
    }
  }
  return result;
};

const OrderUtils = {
  getDefaultCustomDetails,
  ORDER_PAGE_TTL: 10 * 60,
  initialEditOrderState,
};

export default OrderUtils;
